<template>
	<Popup
		v-model="selfDisplay"
		title="消费统计"
		:confirmBtnDisplay="false"
	>
		<div v-loading="loading" style="padding: 15px;">
			<!-- 表格 -->
			<div class="base_table">
				<el-table
					:data="tabData"
					style="width: 100%"
				>
					<el-table-column
						prop="name"
						label="项目"
					>
					</el-table-column>
					<el-table-column
						prop="recharged"
						label="已充值次数"
					>
					</el-table-column>
					<el-table-column
						prop="consumed"
						label="已消费次数"
					>
					</el-table-column>
					<el-table-column
						prop="remain"
						label="剩余次数"
					>
					</el-table-column>
				</el-table>
			</div>
			<!-- 表格 end -->
		</div>
	</Popup>
</template>

<script>
	import Api from "../../../../../api/index.js"
	import { mapState } from "vuex"

	export default {
		model: {
			prop: 'display',
			event: 'changeDisplay'
		},
		props: {
			display: Boolean,
			id: {
				type: [Number, String],
				required: true
			}
		},
		data () {
			return {
				loading: false,
				selfDisplay: false,
				tabData: []
			}
		},
		computed: {
			...mapState(['allProduct'])
		},
		mounted () {
			this.display && (this.selfDisplay = true);
		},
		methods: {
			getData () {
				const that = this;
				that.loading = true;
				var _requestData = {
					uEnterpriseId: that.id
				};
				Api.getOrganizationConsumeCount(_requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.tabData = [];
						for (var i = 0;i < res.data.data.length;i++) {
							for (var ii = 0;ii < that.allProduct.length;ii++) {
								if (res.data.data[i].uversionFlag == that.allProduct[ii].id) {
									that.tabData.push({
										name: that.allProduct[ii].name,
										recharged: res.data.data[i].u_r_total_time || 0,
										consumed: res.data.data[i].u_c_total_time || 0,
										remain: res.data.data[i].urcTime || 0,
									});
								}
							}
						}
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			}
		},
		watch: {
			display (newVal) {
				this.selfDisplay = newVal;
			},
			selfDisplay (newVal) {
				this.$emit("changeDisplay", newVal);
				newVal && this.getData();
				!newVal && (this.tabData = []);
			}
		}
	}
</script>

<style>
</style>
